import React, { ReactNode } from 'react';
import styles from './button.module.scss';

interface IButton {
  label: ReactNode;
  onClick: (e: React.MouseEvent) => void;
  type: 'button' | 'submit' | 'reset' | undefined;
  className?: any;
  disabled?: boolean;
}

const CButton = (props: IButton) => {
  return (
    <button {...props} className={styles.button + ` ${props.className}`}>
      {props.label}
    </button>
  );
};

export default CButton;
